module.exports = __webpack_public_path__ + "img/walking.a1385d6a.svg";